export const TAGS = {
  segment: 'link:charity',
  totalsTagDefinitionId: 'WUCBZCA26RTRD37I97LIER4E1B',
};
